import type { GA4AnalyticsEvent } from '@/domain/shared/types';

export interface PDPClickEventProps {
  element:
    | 'Accordion'
    | 'Read More'
    | 'Element clicked'
    | 'Slider'
    | 'Scroll'
    | 'Clickable text'
    | 'Modal'
    | 'Button'
    | 'Bottom sheet';
  description: string;
  result: string | number | readonly string[] | undefined;
  type?: string;
}

export function createPDPClickEvent({ description, element, type, result }: PDPClickEventProps): GA4AnalyticsEvent {
  return {
    event: 'PDP',
    description,
    element,
    type,
    result: result?.toString().toLowerCase(),
    interaction: true,
  };
}
